import type { ModuleTagEntry } from './index';

/** Transfer Syntax module tags. */
export const tags: ModuleTagEntry[] = [
  'TransferSyntaxUID',
  'AvailableTransferSyntaxUID',
];
